import {KumaViewDto, MenuDto} from "src/services/Client";
import {IReduxState} from "../IReduxState";

export const selectKumaExtraLinks = (state: IReduxState): MenuDto =>
  state.kuma.kumaExtraLinks;
export const selectKumaReqirements = (state: IReduxState): KumaViewDto[] =>
  state.kuma.requirements;



// WEBPACK FOOTER //
// ./src/redux/selectors/kumaSelector.ts